import PageHeading from 'components/molecules/PageHeading';
import { useConfig } from 'context/app-config';
import OrderFooter from 'packages/shared/newOrder/components/OrderFooter';
import { selectCurrentOrder, selectSelectedServices, selectServiceLineDropOffs } from 'pages/newOrder/newOrder.selectors';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import withPageViewAnalytics from 'utils/hoc/withPageViewAnalytics';

import type { NewOrderModule } from '../../types';
import { PickupDropoffOptions } from '../PickupDropoffOptions';

const StyledContainer = styled.div`
  padding-bottom: 70px;
`;

export const PickupDropoff: React.FC<NewOrderModule.IPickupDropoff> = ({ footer }) => {
  const config = useConfig();
  const { t } = useTranslation();
  const { pickupTimeslot, dropoffTimeslot } = useSelector(selectCurrentOrder);
  const selectedServices = useSelector(selectSelectedServices);
  const serviceLineDropoffs = useSelector(selectServiceLineDropOffs);
  const hasSupportForMultipleDropoffs = config?.modules.newOrder.dropoffs?.hasSupportForMultipleDropoffs;

  const isContinueDisabled = useMemo(() => {
    if (hasSupportForMultipleDropoffs) {
      return selectedServices.some((service) => Boolean(serviceLineDropoffs[service]) !== true) || !pickupTimeslot;
    }

    return !(pickupTimeslot && dropoffTimeslot);
  }, [dropoffTimeslot, hasSupportForMultipleDropoffs, pickupTimeslot, selectedServices, serviceLineDropoffs]);

  return (
    <StyledContainer>
      <PageHeading title={t('common.pickUpDropOff')} description={t('newOrderPage.driverPickUpMessage')} />
      <PickupDropoffOptions />
      {footer ?? <OrderFooter isDisabled={isContinueDisabled} />}
    </StyledContainer>
  );
};

export default withPageViewAnalytics({ pageName: 'PickupDropoff' })(PickupDropoff);
